import { useState, useEffect, useRef } from 'react';
import { C } from '../styles/colours.js';
import { supabase } from '../supabase.js';

const SOLO_T = {
  en: { title: '🎯 Solo Play', subtitle: 'How far can you climb? · 3 ❤️', start: '▶ Start Game', startPreview: '▶ Play Free', level: 'Level', score: 'Score', timeUp: "⏰ Time's up!", correct: '✅ Correct!', wrong: '❌ Wrong!', gameOver: 'Game Over', youReached: 'You reached Level', finalScore: 'Final Score', playAgain: '🔁 Play Again', exit: 'Exit', typeAnswer: 'Type your answer...', submit: 'Submit', leaderboard: '🏆 Top Players', bestLevel: 'Best Level', bestScore: 'Best Score', gamesPlayed: 'Games', loading: 'Loading...', youWin: '🏆 YOU WIN!', congrats: 'You completed all 15 levels!', yourStats: 'Your Stats', noScores: 'No scores yet. Be the first!', you: 'You', notEnoughQuestions: 'Not enough questions yet. Check back soon!', back: '← Back', saving: 'Saving...', nicknameLabel: 'YOUR LEADERBOARD NAME', nicknamePlaceholder: 'Enter a nickname...', nicknameRequired: 'Please enter a nickname first', guestPreview: '🎯 Play a full game free — sign in afterwards to save your scores & join the leaderboard!', gateTitle: 'Enjoying it? 🎯', gateDesc: 'Sign in to save your scores and climb the global leaderboard!', gateSignIn: '🔓 Sign In / Sign Up', challengeTitle: '🏆 2-Week Challenge', endsIn: 'Ends in', ended: '🏁 Challenge ended!', dU: 'd', hU: 'h', mU: 'm', ptsShort: 'Points', daysShort: 'Days', rankShort: 'Rank', dailyHint: 'Play daily — +50 pts every day you play!', yourScoreLabel: 'Your Score', lastWinnerLabel: '🏆 Last Challenge Winner', giftMsg: "🎁 We'll contact you soon about your gift!" },
  fr: { title: '🎯 Jeu Solo', subtitle: "Jusqu'où peux-tu aller ? · 3 ❤️", start: '▶ Commencer', startPreview: '▶ Jouer gratuitement', level: 'Niveau', score: 'Score', timeUp: '⏰ Temps écoulé !', correct: '✅ Correct !', wrong: '❌ Faux !', gameOver: 'Partie terminée', youReached: 'Tu as atteint le niveau', finalScore: 'Score final', playAgain: '🔁 Rejouer', exit: 'Quitter', typeAnswer: 'Tape ta réponse...', submit: 'Valider', leaderboard: '🏆 Meilleurs joueurs', bestLevel: 'Meilleur niveau', bestScore: 'Meilleur score', gamesPlayed: 'Parties', loading: 'Chargement...', youWin: '🏆 GAGNÉ !', congrats: 'Tu as fini les 15 niveaux !', yourStats: 'Tes stats', noScores: 'Pas encore de scores. Sois le premier !', you: 'Toi', notEnoughQuestions: 'Pas assez de questions encore.', back: '← Retour', saving: 'Enregistrement...', nicknameLabel: 'TON NOM AU CLASSEMENT', nicknamePlaceholder: 'Entre un pseudo...', nicknameRequired: "Entre d'abord un pseudo", guestPreview: '🎯 Joue une partie complète gratuitement — connecte-toi ensuite pour sauver tes scores & rejoindre le classement !', gateTitle: 'Ça te plaît ? 🎯', gateDesc: 'Connecte-toi pour sauver tes scores et grimper au classement mondial !', gateSignIn: '🔓 Se connecter / S\'inscrire', challengeTitle: '🏆 Défi de 2 Semaines', endsIn: 'Se termine dans', ended: '🏁 Défi terminé !', dU: 'j', hU: 'h', mU: 'min', ptsShort: 'Points', daysShort: 'Jours', rankShort: 'Rang', dailyHint: 'Joue chaque jour — +50 pts par jour joué !', yourScoreLabel: 'Ton Score', lastWinnerLabel: '🏆 Gagnant du dernier défi', giftMsg: '🎁 On te contactera bientôt pour ton cadeau !' },
  ar: { title: '🎯 لعب فردي', subtitle: 'إلى أي مدى تستطيع الوصول؟ · 3 ❤️', start: '▶ ابدأ', startPreview: '▶ العب مجانًا', level: 'المستوى', score: 'النقاط', timeUp: '⏰ انتهى الوقت!', correct: '✅ صحيح!', wrong: '❌ خطأ!', gameOver: 'انتهت اللعبة', youReached: 'وصلت إلى المستوى', finalScore: 'النتيجة النهائية', playAgain: '🔁 العب مرة أخرى', exit: 'خروج', typeAnswer: 'اكتب إجابتك...', submit: 'تأكيد', leaderboard: '🏆 أفضل اللاعبين', bestLevel: 'أفضل مستوى', bestScore: 'أفضل نتيجة', gamesPlayed: 'الألعاب', loading: 'تحميل...', youWin: '🏆 فزت!', congrats: 'أكملت كل المستويات!', yourStats: 'إحصائياتك', noScores: 'لا توجد نقاط بعد. كن الأول!', you: 'أنت', notEnoughQuestions: 'لا توجد أسئلة كافية.', back: '← رجوع', saving: 'حفظ...', nicknameLabel: 'اسمك في لوحة المتصدرين', nicknamePlaceholder: 'أدخل لقبًا...', nicknameRequired: 'أدخل لقبًا أولاً', guestPreview: '🎯 العب لعبة كاملة مجانًا — سجّل دخولك بعدها لحفظ نتائجك والانضمام إلى لوحة المتصدرين!', gateTitle: 'هل أعجبتك؟ 🎯', gateDesc: 'سجّل دخولك لحفظ نتائجك والصعود في لوحة المتصدرين العالمية!', gateSignIn: '🔓 تسجيل الدخول / حساب جديد', challengeTitle: '🏆 تحدي أسبوعين', endsIn: 'ينتهي خلال', ended: '🏁 انتهى التحدي!', dU: 'ي', hU: 'س', mU: 'د', ptsShort: 'نقاط', daysShort: 'أيام', rankShort: 'الترتيب', dailyHint: 'العب يوميًا — +50 نقطة كل يوم تلعب فيه!', yourScoreLabel: 'نتيجتك', lastWinnerLabel: '🏆 الفائز في التحدي السابق', giftMsg: '🎁 سنتواصل معك قريبًا بخصوص جائزتك!' },
  es: { title: '🎯 Juego Solo', subtitle: '¿Hasta dónde puedes llegar? · 3 ❤️', start: '▶ Empezar', startPreview: '▶ Jugar gratis', level: 'Nivel', score: 'Puntos', timeUp: '⏰ ¡Tiempo agotado!', correct: '✅ ¡Correcto!', wrong: '❌ ¡Falso!', gameOver: 'Juego terminado', youReached: 'Llegaste al nivel', finalScore: 'Puntaje final', playAgain: '🔁 Jugar otra vez', exit: 'Salir', typeAnswer: 'Escribe tu respuesta...', submit: 'Enviar', leaderboard: '🏆 Mejores jugadores', bestLevel: 'Mejor nivel', bestScore: 'Mejor puntaje', gamesPlayed: 'Juegos', loading: 'Cargando...', youWin: '🏆 ¡GANASTE!', congrats: '¡Completaste los 15 niveles!', yourStats: 'Tus stats', noScores: '¡No hay puntajes. Sé el primero!', you: 'Tú', notEnoughQuestions: 'No hay suficientes preguntas aún.', back: '← Atrás', saving: 'Guardando...', nicknameLabel: 'TU NOMBRE EN LA CLASIFICACIÓN', nicknamePlaceholder: 'Ingresa un apodo...', nicknameRequired: 'Ingresa un apodo primero', guestPreview: '🎯 Juega una partida completa gratis — inicia sesión después para guardar tus puntajes y unirte a la clasificación!', gateTitle: '¿Te gusta? 🎯', gateDesc: '¡Inicia sesión para guardar tus puntajes y subir en la clasificación mundial!', gateSignIn: '🔓 Iniciar sesión / Registrarse', challengeTitle: '🏆 Desafío de 2 Semanas', endsIn: 'Termina en', ended: '🏁 ¡Desafío terminado!', dU: 'd', hU: 'h', mU: 'm', ptsShort: 'Puntos', daysShort: 'Días', rankShort: 'Rango', dailyHint: '¡Juega cada día — +50 pts por cada día que juegas!', yourScoreLabel: 'Tu Puntaje', lastWinnerLabel: '🏆 Ganador del último desafío', giftMsg: '🎁 ¡Te contactaremos pronto por tu regalo!' },
};

const MAX_LEVEL = 15;
const QUESTIONS_PER_LEVEL = 5;
const TOTAL_Q = MAX_LEVEL * QUESTIONS_PER_LEVEL;
const STARTING_HEARTS = 3;
const FEEDBACK_DELAY = 1600;
const NICK_KEY = 'tabliq-solo-nickname';

// All levels are multiple-choice now. To re-enable typing for top levels,
// change this back to: const isMcqLevel = (lvl) => lvl <= 7;
const isMcqLevel = () => true;
// Timer tightens as you climb: 15s (easy) → 12s (mid) → 10s (hard)
const levelTimer = (lvl) => (lvl <= 5 ? 15 : lvl <= 10 ? 12 : 10);

// ===== Smart distractor helpers =====
const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);

const isNumeric = (s) => {
  const str = String(s).trim();
  return /\d/.test(str) && /^[\d.,\s]+$/.test(str);
};

// Pick up to n unique answers (case-insensitive), excluding the correct one
const pickUnique = (candidates, excludeLower, n) => {
  const out = [];
  const seen = new Set([excludeLower]);
  for (const c of candidates) {
    const key = (c || '').trim().toLowerCase();
    if (!c || seen.has(key)) continue;
    seen.add(key);
    out.push(c);
    if (out.length >= n) break;
  }
  return out;
};

// For numeric answers, build believable nearby numbers
const makeNumberDistractors = (correct) => {
  const hasComma = String(correct).includes(',');
  const n = parseInt(String(correct).replace(/[.,\s]/g, ''), 10);
  if (isNaN(n)) return [];
  const cands = new Set();
  let rels;
  if (n < 10) rels = [n + 1, n + 2, n - 1, n - 2, n + 3, n + 4];
  else if (n < 100) rels = [n + 5, n - 5, n + 10, n - 10, n + 2, n - 2, n + 20];
  else rels = [Math.round(n * 1.5), Math.round(n * 0.5), Math.round(n * 1.25), Math.round(n * 0.75), n + 50, n - 50];
  for (const r of rels) if (r !== n && r > 0) cands.add(r);
  let i = 3;
  while (cands.size < 3) { const c = n + i; if (c !== n && c > 0) cands.add(c); i++; }
  return shuffle([...cands]).slice(0, 3).map(x => (hasComma ? x.toLocaleString('en-US') : String(x)));
};

function SoloPlay({ onBack, onLogin, lang = 'en', user }) {
  const t = SOLO_T[lang] || SOLO_T.en;
  const isRTL = lang === 'ar';

  const [screen, setScreen] = useState('start');
  const [allQuestions, setAllQuestions] = useState([]);
  const [gameQuestions, setGameQuestions] = useState([]);
  const [currentQIdx, setCurrentQIdx] = useState(0);
  const [level, setLevel] = useState(1);
  const [hearts, setHearts] = useState(STARTING_HEARTS);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(15);
  const [typedAnswer, setTypedAnswer] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [mcqOptions, setMcqOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [wonGame, setWonGame] = useState(false);
  const [nickname, setNickname] = useState('');
  const [totalPlayers, setTotalPlayers] = useState(0);

  // ===== Competition state =====
  const [competition, setCompetition] = useState(null);
  const [myStats, setMyStats] = useState(null); // { total_points, days_played, final_score, rank }
  const [now, setNow] = useState(Date.now());
  const [lastWinner, setLastWinner] = useState(null); // winner of the previous (ended) challenge

  const stateRef = useRef({ hearts: STARTING_HEARTS, level: 1, score: 0, currentQIdx: 0 });
  const answeringRef = useRef(false);

  useEffect(() => {
    stateRef.current = { hearts, level, score, currentQIdx };
  }, [hearts, level, score, currentQIdx]);

  useEffect(() => {
    loadGameData();
  }, []);

  // Live countdown: tick every second, but only while on the Solo home screen
  // (so it never causes re-renders during an actual game).
  useEffect(() => {
    if (screen !== 'start') return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [screen]);

  useEffect(() => {
    const saved = localStorage.getItem(NICK_KEY);
    if (myStats?.player_name) {
      setNickname(myStats.player_name);
    } else if (saved) {
      setNickname(saved);
    } else if (user) {
      setNickname(user.user_metadata?.full_name || user.email?.split('@')[0] || '');
    }
  }, [myStats, user]);

  useEffect(() => {
    if (screen !== 'playing' || feedback) return;
    if (timeLeft <= 0) {
      handleTimeUp();
      return;
    }
    const id = setTimeout(() => setTimeLeft(prev => prev - 1), 1000);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, feedback, screen]);

  const loadGameData = async () => {
    setLoading(true);
    const { data: questions } = await supabase.from('questions').select('*');
    if (questions) setAllQuestions(questions);
    await loadCompetitionData();
    setLoading(false);
  };

  const loadCompetitionData = async () => {
    // Active competition (most recent active row)
    const { data: comp } = await supabase
      .from('competition').select('*').eq('status', 'active')
      .order('starts_at', { ascending: false }).limit(1).maybeSingle();
    setCompetition(comp || null);

    // Winner of the most recent finished challenge (to show a banner)
    const { data: ended } = await supabase
      .from('competition').select('winner_name, winner_email, ends_at')
      .eq('status', 'ended').not('winner_name', 'is', null)
      .order('ends_at', { ascending: false }).limit(1).maybeSingle();
    setLastWinner(ended || null);

    // Top 10 leaderboard from the view
    const { data: top } = await supabase
      .from('solo_leaderboard').select('*')
      .order('final_score', { ascending: false }).limit(10);
    setLeaderboard(top || []);

    // Total players in the challenge
    const { count } = await supabase
      .from('solo_leaderboard').select('*', { count: 'exact', head: true });
    setTotalPlayers(count || 0);

    // My own stats + rank
    if (user?.email) {
      const { data: mine } = await supabase
        .from('solo_leaderboard').select('*').eq('user_email', user.email).maybeSingle();
      if (mine) {
        const { count: better } = await supabase
          .from('solo_leaderboard').select('*', { count: 'exact', head: true })
          .gt('final_score', mine.final_score);
        setMyStats({ ...mine, rank: (better || 0) + 1 });
      } else {
        setMyStats(null);
      }
    }
  };

  const startGame = () => {
    if (allQuestions.length < TOTAL_Q) {
      alert(t.notEnoughQuestions);
      return;
    }
    if (user && !nickname.trim()) {
      alert(t.nicknameRequired);
      return;
    }
    if (nickname.trim()) localStorage.setItem(NICK_KEY, nickname.trim());

    const shuffled = [...allQuestions].sort(() => Math.random() - 0.5);
    const picked = shuffled.slice(0, TOTAL_Q);
    setGameQuestions(picked);
    setCurrentQIdx(0);
    setLevel(1);
    setHearts(STARTING_HEARTS);
    setScore(0);
    setFeedback(null);
    setTypedAnswer('');
    setWonGame(false);
    answeringRef.current = false;
    stateRef.current = { hearts: STARTING_HEARTS, level: 1, score: 0, currentQIdx: 0 };
    setScreen('playing');
    buildOptions(picked[0], 1);
    setTimeLeft(levelTimer(1));
  };

  const buildOptions = (q, lvl) => {
    if (!isMcqLevel(lvl)) {
      setMcqOptions([]);
      setTypedAnswer('');
      return;
    }
    const correct = q[`a_${lang}`] || q.a_en;
    if (!correct) { setMcqOptions([]); return; }
    const correctLower = correct.trim().toLowerCase();

    let wrongs = [];
    if (isNumeric(correct)) {
      wrongs = makeNumberDistractors(correct);
    } else {
      const toAns = (list) => list.map(o => o[`a_${lang}`] || o.a_en).filter(Boolean);
      const sameSub = toAns(allQuestions.filter(o => o.id !== q.id && o.subcategory && o.subcategory === q.subcategory));
      const sameCat = toAns(allQuestions.filter(o => o.id !== q.id && o.category && o.category === q.category));
      const anyA = toAns(allQuestions.filter(o => o.id !== q.id));
      // Higher levels lean on same-subcategory answers (harder).
      // Early levels use same-category (plausible but a bit easier).
      const ordered = lvl >= 6
        ? [...shuffle(sameSub), ...shuffle(sameCat), ...shuffle(anyA)]
        : [...shuffle(sameCat), ...shuffle(sameSub), ...shuffle(anyA)];
      wrongs = pickUnique(ordered, correctLower, 3);
    }

    // Safety: if somehow short, top up from the whole bank
    if (wrongs.length < 3 && !isNumeric(correct)) {
      const fill = pickUnique(
        shuffle(allQuestions.map(o => o[`a_${lang}`] || o.a_en).filter(Boolean)),
        correctLower,
        3 - wrongs.length
      );
      wrongs = [...wrongs, ...fill.filter(f => !wrongs.some(w => w.toLowerCase() === f.toLowerCase()))];
    }

    setMcqOptions(shuffle([correct, ...wrongs]));
  };

  const handleTimeUp = () => {
    if (answeringRef.current) return;
    answeringRef.current = true;
    setFeedback('timeup');
    const newHearts = stateRef.current.hearts - 1;
    stateRef.current.hearts = newHearts;
    setHearts(newHearts);
    setTimeout(() => advance(newHearts), FEEDBACK_DELAY);
  };

  const handleAnswer = (answer) => {
    if (answeringRef.current) return;
    if (!answer || !answer.trim()) return;
    answeringRef.current = true;

    const q = gameQuestions[stateRef.current.currentQIdx];
    const correct = (q[`a_${lang}`] || q.a_en || '').trim().toLowerCase();
    const userAns = answer.trim().toLowerCase();
    const lvl = stateRef.current.level;

    if (userAns === correct) {
      const bonus = Math.round((timeLeft / levelTimer(lvl)) * 10);
      const earned = 10 * lvl + bonus;
      const newScore = stateRef.current.score + earned;
      stateRef.current.score = newScore;
      setScore(newScore);
      setFeedback('correct');
      setTimeout(() => advance(stateRef.current.hearts), FEEDBACK_DELAY);
    } else {
      setFeedback('wrong');
      const newHearts = stateRef.current.hearts - 1;
      stateRef.current.hearts = newHearts;
      setHearts(newHearts);
      setTimeout(() => advance(newHearts), FEEDBACK_DELAY);
    }
  };

  const advance = (currentHearts) => {
    const nextIdx = stateRef.current.currentQIdx + 1;
    if (currentHearts <= 0) {
      endGame(false);
      return;
    }
    if (nextIdx >= TOTAL_Q) {
      endGame(true);
      return;
    }
    const newLevel = Math.floor(nextIdx / QUESTIONS_PER_LEVEL) + 1;
    stateRef.current.currentQIdx = nextIdx;
    stateRef.current.level = newLevel;
    answeringRef.current = false;
    setCurrentQIdx(nextIdx);
    setLevel(newLevel);
    setTypedAnswer('');
    buildOptions(gameQuestions[nextIdx], newLevel);
    setFeedback(null);
    setTimeLeft(levelTimer(newLevel));
  };

  const endGame = async (won) => {
    setWonGame(won);
    setScreen('gameover');

    if (user?.email) {
      setSaving(true);
      const finalScore = stateRef.current.score;
      const finalName = (nickname && nickname.trim()) || user.email?.split('@')[0] || 'Player';

      // Record THIS game into the competition scoring table
      await supabase.from('solo_scores').insert({
        user_email: user.email,
        player_name: finalName,
        score: finalScore,
        played_at: new Date().toISOString(),
      });

      await loadCompetitionData();
      setSaving(false);
    }
  };

  // ===== Countdown helper =====
  const getCountdown = () => {
    if (!competition?.ends_at) return null;
    const end = new Date(competition.ends_at).getTime();
    if (isNaN(end)) return null;
    let diff = end - now;
    if (diff <= 0) return { ended: true };
    const d = Math.floor(diff / 86400000); diff -= d * 86400000;
    const h = Math.floor(diff / 3600000); diff -= h * 3600000;
    const m = Math.floor(diff / 60000); diff -= m * 60000;
    const s = Math.floor(diff / 1000);
    return { ended: false, d, h, m, s };
  };

  // ===== RENDER =====
  if (loading) {
    return (
      <div dir={isRTL ? 'rtl' : 'ltr'} style={{ background: C.bg, minHeight: '100vh', color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
        {t.loading}
      </div>
    );
  }

  const countdown = getCountdown();

  if (screen === 'start') {
    return (
      <div dir={isRTL ? 'rtl' : 'ltr'} style={{ background: C.bg, minHeight: '100vh', color: C.white, padding: 20, maxWidth: 480, margin: '0 auto', fontFamily: 'sans-serif' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.textSub, fontSize: 14, cursor: 'pointer', marginBottom: 20 }}>{t.back}</button>

        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <div style={{ fontSize: 28, fontWeight: 900, marginBottom: 6 }}>{t.title}</div>
          <div style={{ fontSize: 13, color: C.textSub }}>{t.subtitle}</div>
        </div>

        {/* ===== Previous challenge winner banner ===== */}
        {lastWinner && lastWinner.winner_name && (
          <div style={{ background: `linear-gradient(135deg, ${C.gold}33, ${C.gold}11)`, border: `1px solid ${C.gold}`, borderRadius: 16, padding: 14, marginBottom: 14, textAlign: 'center' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.gold, letterSpacing: 1, marginBottom: 4 }}>{t.lastWinnerLabel}</div>
            <div style={{ fontSize: 20, fontWeight: 900, color: C.white }}>🎉 {lastWinner.winner_name} 🎉</div>
            <div style={{ fontSize: 12, color: C.green, fontWeight: 700, marginTop: 6 }}>{t.giftMsg}</div>
          </div>
        )}

        {/* ===== Challenge countdown banner ===== */}
        {competition && countdown && (
          <div style={{ background: `linear-gradient(135deg, ${C.gold}22, ${C.purple}22)`, border: `1px solid ${C.gold}55`, borderRadius: 16, padding: 16, marginBottom: 18, textAlign: 'center' }}>
            <div style={{ fontSize: 14, fontWeight: 900, color: C.gold, marginBottom: 6 }}>{t.challengeTitle}</div>
            {countdown.ended ? (
              <div style={{ fontSize: 16, fontWeight: 800, color: C.white }}>{t.ended}</div>
            ) : (
              <>
                <div style={{ fontSize: 11, color: C.textSub, marginBottom: 4, letterSpacing: 1 }}>{t.endsIn}</div>
                <div style={{ fontSize: 24, fontWeight: 900, color: C.white, letterSpacing: 1 }}>
                  {countdown.d > 0 ? `${countdown.d}${t.dU} ` : ''}
                  {String(countdown.h).padStart(2, '0')}:{String(countdown.m).padStart(2, '0')}:{String(countdown.s).padStart(2, '0')}
                </div>
                <div style={{ fontSize: 11, color: C.green, fontWeight: 700, marginTop: 8 }}>{t.dailyHint}</div>
              </>
            )}
          </div>
        )}

        {user && (
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.textMuted, marginBottom: 6, letterSpacing: 1 }}>{t.nicknameLabel}</div>
            <input
              type="text"
              value={nickname}
              maxLength={20}
              onChange={e => { setNickname(e.target.value); localStorage.setItem(NICK_KEY, e.target.value); }}
              placeholder={t.nicknamePlaceholder}
              style={{ width: '100%', background: C.inputBg, border: `1px solid ${C.inputBorder}`, borderRadius: 10, padding: '12px 14px', fontSize: 14, color: C.white, outline: 'none', boxSizing: 'border-box' }}
            />
          </div>
        )}

        {user && myStats && (
          <div style={{ background: `${C.purple}15`, border: `1px solid ${C.purple}40`, borderRadius: 14, padding: 16, marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: C.purple, marginBottom: 10, letterSpacing: 1 }}>{t.yourStats}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 22, fontWeight: 900, color: C.gold }}>{myStats.total_points}</div>
                <div style={{ fontSize: 10, color: C.textMuted }}>{t.ptsShort}</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 22, fontWeight: 900, color: C.green }}>{myStats.days_played}</div>
                <div style={{ fontSize: 10, color: C.textMuted }}>{t.daysShort}</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 22, fontWeight: 900, color: C.white }}>#{myStats.rank}</div>
                <div style={{ fontSize: 10, color: C.textMuted }}>{t.rankShort}</div>
              </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: 12, paddingTop: 12, borderTop: `1px solid ${C.border}` }}>
              <span style={{ fontSize: 11, color: C.textMuted }}>{t.yourScoreLabel}: </span>
              <span style={{ fontSize: 18, fontWeight: 900, color: C.gold }}>{myStats.final_score}</span>
            </div>
          </div>
        )}

        {!user && (
          <div style={{ background: `${C.purple}15`, border: `1px solid ${C.purple}40`, borderRadius: 12, padding: 14, marginBottom: 20, textAlign: 'center', fontSize: 12, color: C.purple, lineHeight: 1.5 }}>
            {t.guestPreview}
          </div>
        )}

        <button onClick={startGame} style={{ width: '100%', background: C.purple, color: C.white, border: 'none', borderRadius: 16, padding: 18, fontSize: 18, fontWeight: 900, cursor: 'pointer', marginBottom: 24, boxShadow: `0 8px 30px ${C.purple}50` }}>
          {user ? t.start : t.startPreview}
        </button>

        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.gold }}>{t.leaderboard}</div>
            <div style={{ fontSize: 11, color: C.textMuted }}>🌍 {totalPlayers}</div>
          </div>
          {leaderboard.length === 0 && (
            <div style={{ background: C.card, border: `1px dashed ${C.border}`, borderRadius: 12, padding: 20, textAlign: 'center', color: C.textMuted, fontSize: 13 }}>{t.noScores}</div>
          )}
          {leaderboard.map((entry, i) => (
            <div key={entry.user_email} style={{ display: 'flex', alignItems: 'center', gap: 10, background: C.card, border: `1px solid ${user && entry.user_email === user.email ? C.purple : C.border}`, borderRadius: 10, padding: '10px 12px', marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 900, color: i === 0 ? C.gold : i === 1 ? '#C0C0C0' : i === 2 ? '#CD7F32' : C.textSub, minWidth: 24 }}>
                {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i + 1}`}
              </div>
              <div style={{ flex: 1, fontSize: 13, fontWeight: 600 }}>
                {entry.player_name}
                {user && entry.user_email === user.email && <span style={{ fontSize: 10, color: C.purple, marginLeft: 6 }}>({t.you})</span>}
              </div>
              <div style={{ fontSize: 11, color: C.textMuted, fontWeight: 700 }}>{entry.days_played}{t.dU}</div>
              <div style={{ fontSize: 12, color: C.green, fontWeight: 700, minWidth: 50, textAlign: 'right' }}>{entry.final_score}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (screen === 'playing') {
    const q = gameQuestions[currentQIdx];
    if (!q) return null;
    const questionText = q[`q_${lang}`] || q.q_en;
    const mcq = isMcqLevel(level);
    const timerMax = levelTimer(level);
    const correctAnswerText = q[`a_${lang}`] || q.a_en;

    return (
      <div dir={isRTL ? 'rtl' : 'ltr'} style={{ background: C.bg, minHeight: '100vh', color: C.white, padding: 20, maxWidth: 480, margin: '0 auto', fontFamily: 'sans-serif' }}>
        <div style={{ marginBottom: 12 }}>
          <button onClick={() => setScreen('start')} style={{ background: C.card, border: `1px solid ${C.border}`, color: C.textSub, borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>✕ {t.exit}</button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: C.purple }}>{t.level} {level}</div>
          <div style={{ fontSize: 16 }}>{'❤️'.repeat(Math.max(0, hearts))}{'🖤'.repeat(STARTING_HEARTS - Math.max(0, hearts))}</div>
          <div style={{ fontSize: 13, fontWeight: 800, color: C.gold }}>{t.score}: {score}</div>
        </div>

        <div style={{ height: 8, background: C.card, borderRadius: 4, overflow: 'hidden', marginBottom: 24 }}>
          <div style={{ height: '100%', width: `${(timeLeft / timerMax) * 100}%`, background: timeLeft > timerMax * 0.3 ? C.green : C.red, transition: 'width 1s linear, background 0.3s' }} />
        </div>

        <div style={{ fontSize: 11, color: C.textMuted, marginBottom: 8, letterSpacing: 1 }}>
          Q{(currentQIdx % QUESTIONS_PER_LEVEL) + 1}/{QUESTIONS_PER_LEVEL} · {timeLeft}s {mcq ? '· MCQ' : '· ⌨️'}
        </div>

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, marginBottom: 16, minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', fontSize: 17, fontWeight: 700, lineHeight: 1.4 }}>
          {questionText}
        </div>

        {feedback && (
          <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 900, color: feedback === 'correct' ? C.green : C.red, marginBottom: 12 }}>
            {feedback === 'correct' ? t.correct : feedback === 'timeup' ? t.timeUp : t.wrong}
            {feedback !== 'correct' && (
              <div style={{ background: `${C.green}12`, border: `1px solid ${C.green}40`, borderRadius: 12, padding: '12px 16px', marginTop: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: C.textMuted, marginBottom: 4 }}>✓ {({ en: 'CORRECT ANSWER', fr: 'BONNE RÉPONSE', ar: 'الإجابة الصحيحة', es: 'RESPUESTA CORRECTA' }[lang]) || 'CORRECT ANSWER'}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: C.green, lineHeight: 1.4 }}>{correctAnswerText}</div>
              </div>
            )}
          </div>
        )}

        {mcq && !feedback && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {mcqOptions.map((opt, i) => (
              <button key={i} onClick={() => handleAnswer(opt)} style={{ background: C.card, color: C.white, border: `2px solid ${C.purple}50`, borderRadius: 12, padding: '14px 10px', fontSize: 14, fontWeight: 700, cursor: 'pointer', minHeight: 60, wordBreak: 'break-word' }}>
                {String.fromCharCode(65 + i)}. {opt}
              </button>
            ))}
          </div>
        )}

        {!mcq && !feedback && (
          <div>
            <input
              autoFocus
              type="text"
              value={typedAnswer}
              onChange={e => setTypedAnswer(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleAnswer(typedAnswer)}
              placeholder={t.typeAnswer}
              style={{ width: '100%', background: C.inputBg, border: `2px solid ${C.purple}`, borderRadius: 12, padding: '14px 16px', fontSize: 16, color: C.white, outline: 'none', boxSizing: 'border-box', marginBottom: 10 }}
            />
            <button
              onClick={() => handleAnswer(typedAnswer)}
              disabled={!typedAnswer.trim()}
              style={{ width: '100%', background: typedAnswer.trim() ? C.purple : 'rgba(255,255,255,0.1)', color: typedAnswer.trim() ? C.white : C.textMuted, border: 'none', borderRadius: 12, padding: 14, fontSize: 15, fontWeight: 800, cursor: typedAnswer.trim() ? 'pointer' : 'not-allowed' }}
            >
              {t.submit}
            </button>
          </div>
        )}
      </div>
    );
  }

  if (screen === 'gameover') {
    return (
      <div dir={isRTL ? 'rtl' : 'ltr'} style={{ background: C.bg, minHeight: '100vh', color: C.white, padding: 20, maxWidth: 480, margin: '0 auto', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 60, marginBottom: 14 }}>{wonGame ? '🏆' : '🎮'}</div>
          <div style={{ fontSize: 28, fontWeight: 900, marginBottom: 8, color: wonGame ? C.gold : C.white }}>
            {wonGame ? t.youWin : t.gameOver}
          </div>
          {wonGame && <div style={{ fontSize: 14, color: C.textSub, marginBottom: 12 }}>{t.congrats}</div>}
          <div style={{ fontSize: 16, color: C.textSub, marginBottom: 4 }}>{t.youReached} <span style={{ color: C.purple, fontWeight: 800 }}>{level}</span></div>
          <div style={{ fontSize: 16, color: C.textSub }}>{t.finalScore}: <span style={{ color: C.gold, fontWeight: 900, fontSize: 22 }}>{score}</span></div>
          {saving && <div style={{ fontSize: 12, color: C.textMuted, marginTop: 12 }}>{t.saving}</div>}
        </div>

        {level >= 5 && (
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 32, letterSpacing: 6 }}>
              {level >= 5 && '🥉'}
              {level >= 10 && '🥈'}
              {level >= 15 && wonGame && '🥇'}
            </div>
          </div>
        )}

        {!user && (
          <div style={{ background: `${C.purple}15`, border: `1px solid ${C.purple}40`, borderRadius: 14, padding: 16, marginBottom: 14, textAlign: 'center' }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.purple, marginBottom: 6 }}>{t.gateTitle}</div>
            <div style={{ fontSize: 13, color: C.textSub, lineHeight: 1.5, marginBottom: 14 }}>{t.gateDesc}</div>
            <button onClick={onLogin} style={{ width: '100%', background: C.purple, color: C.white, border: 'none', borderRadius: 12, padding: 14, fontSize: 15, fontWeight: 900, cursor: 'pointer', boxShadow: `0 6px 20px ${C.purple}50` }}>
              {t.gateSignIn}
            </button>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => setScreen('start')} style={{ flex: 1, background: C.card, border: `1px solid ${C.border}`, color: C.white, borderRadius: 14, padding: 14, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            {t.exit}
          </button>
          <button onClick={startGame} style={{ flex: 2, background: C.purple, color: C.white, border: 'none', borderRadius: 14, padding: 14, fontSize: 15, fontWeight: 900, cursor: 'pointer' }}>
            {t.playAgain}
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default SoloPlay;